/* eslint-disable @typescript-eslint/ban-types */
import { useTranslation } from 'react-i18next';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { IconButton } from '@mui/material';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { PALETTE } from '~/assets/styles/base';
import Checkbox from '~/components/ui-elements/Checkbox';

const PageBreak = styled.h2`
  width: 768px;
  text-align: center;
  border-bottom: 1px dashed ${PALETTE.text.sub};
  line-height: 0.4m;
  margin-bottom: 10px;
`;

const PageBreakSpan = styled.span`
  padding: 0 10px 0px 20px;
  color: ${PALETTE.text.sub};
  font-size: 14px;
  background-color: #fafbfc;
  position: relative;
  top: 8px;
`;

const DeleteIcon = styled(DeleteOutlineIcon)`
  font-size: 20px;
  color: ${PALETTE.text.sub};
  background-color: #fafbfc;
`;

const PageBreakBox = styled.div`
  width: 768px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 5px;
`;

const CheckBoxDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 768px;
`;

type Props = {
  onClickDelete: Function;
  itemIdx: number;
  isGotoEndEnabled: boolean;
  isGotoEndChecked: boolean;
  handleGotoEndChange: Function;
  id: string;
};

const PageBreakItem: React.FC<Props> = ({
  onClickDelete,
  itemIdx,
  isGotoEndEnabled,
  isGotoEndChecked,
  handleGotoEndChange,
  id,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id,
    disabled: true,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  return (
    <PageBreakBox style={style} ref={setNodeRef} {...attributes} {...listeners}>
      <CheckBoxDiv>
        <Checkbox
          label={t('registration.originalForm.manual.componentControl.gotoEndEnable')}
          name="gotoEndEnabled"
          checked={isGotoEndChecked || false}
          handleChange={() => {
            handleGotoEndChange(itemIdx, isGotoEndChecked);
          }}
          dataTestId={`${itemIdx}-goto-end-enabled`}
          value="gotoEndEnabled"
          fontSize={24}
          labelFontSize="14px"
          disabled={!isGotoEndEnabled}
        />
      </CheckBoxDiv>

      <PageBreak data-testid="pageBreakItem">
        <PageBreakSpan>{t('registration.originalForm.manual.pageBreak.newPage')}</PageBreakSpan>
        <IconButton
          style={{
            backgroundColor: '#fafbfc',
            marginBottom: '-16px',
            position: 'relative',
            paddingRight: '10px',
          }}
          onClick={() => {
            onClickDelete(itemIdx);
          }}
          aria-label={`${itemIdx}-deletePage`}
        >
          <DeleteIcon />
        </IconButton>
      </PageBreak>
    </PageBreakBox>
  );
};

export default PageBreakItem;
